import { Page } from '@/components';
import {
  Card,
  CryptoIcon,
  EtherScanPictogram,
  Flex,
  Heading
} from '@blockanalitica/ui';
import PreFarmingKpi from './PreFarmingKpi';
import SPKDistribution from './SPKDistribution';
import SPKDistributionChart from './SPKDistributionChart';
import StakingKpi from './StakingKpi';
import TopAirdropWallets from './TopAirdropWallets';
import TopStakedWallets from './TopStakedWallets';
import TopHolders from './token/TopHolders';
import TokenInfo from './tokenInfo';

export default function SPKPage() {
  return (
    <Page
      title={
        <Flex alignItems="baseline" gap="xs" alignContent="center">
          <CryptoIcon
            name="SPK"
            address="0x00000000000000000000000000000000000spark"
            size="4"
          />
          <Heading>SPK Token</Heading>
          <a
            href="https://etherscan.io/address/0xc20059e0317de91738d13af027dfc4a50781b066"
            target="_blank"
            rel="noreferrer">
            <EtherScanPictogram size="0" />
          </a>
        </Flex>
      }>
      <StakingKpi />
      <TopStakedWallets />

      <SPKDistribution />
      <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
        <SPKDistributionChart flexBasis="70%" />
        <Card gap="xs" flexBasis="30%">
          <TokenInfo />
        </Card>
      </Flex>
      <TopHolders
        symbol="SPK"
        address="0xc20059e0317de91738d13af027dfc4a50781b066"
        linkTo="token/holders"
      />
      <PreFarmingKpi />
      <TopAirdropWallets />
    </Page>
  );
}
